export default {
    account_existed: "Хэрэглэгчийн нэр байхгүй.",
    account_not_exists: "Хэрэглэгчийн нэр байхгүй.",

    invalid_password: "Нууц үг буруу байна!",
    insufficient_balance: "Үлдэгдэл хангалтгүй!",

    // verify_failed: "Verification number incorrect",

    withdrawalAmountMustGreaterThan0: "Татан авалтын дүн 0-ээс их байх ёстой.",
    block: "Таны бүртгэл хаагдсан байна",

    requestTooFrequentAtLeast2Minutes: "Хэт олон удаа хүсэлт гаргах. 2 минутын дараа дахин оролдоно уу.",

    invalidPasswordFormat: "Нууц үгээ өөрөө үүсгэ. Нууц үг 8-20 тэмдэгтээс бүрдэх ба тоо үсэгний хослол байх ёстой.",
    isRequired: "{fname}-г бөглөнө үү.",
    isMinValue: "{fname} хамгийн багадаа {fvalue} байх ёстой.",
    isMaxValue: "{fname} нь {fvalue}-с бага эсвэл тэнцүү байх ёстой.",
    isMinLength: "{fname} хамгийн багадаа {fvalue} тэмдэгттэй байх ёстой.",
    isMaxLength: "{fname} нь {fvalue} тэмдэгтээс бага буюу тэнцүү байх ёстой.",
    isAlpha: "{fname} зөвхөн цагаан толгойн үсгийг хүлээн зөвшөөрдөг.",
    isAlphaNum: "{fname} зөвхөн үсэг тоогоор бичдэг.",
    isNumeric: "{fname} зөвхөн тоонуудыг хүлээн зөвшөөрдөг.",
    isEmail: "{fname} зөвхөн хүчинтэй имэйл хаягийг хүлээн авна.",
    isIpAddress: "{fname} зөвхөн хүчинтэй IPv4 хаягуудыг хүлээн авдаг.",
    isSameAs: "{fname} нь {fname2}-тэй ижил байх ёстой.",
    isUrl: "{fname} зөвхөн URL-г хүлээн зөвшөөрнө.",
    containAlphaNum: "{fname} дор хаяж нэг цагаан толгой нэг тоотой байх ёстой.",
    selectOption: "{fname} сонгоно уу",
    notSameAs: "{fname} болон {fname2} ижил байж болохгүй.",
    isBetween: "{fname} {min} болон {max} хооронд байх ёстой.",
    checkFormat: "Хүлээн авагчийн утасны дугаарыг дараах форматаар бөглөнө үү: 0123456789 эсвэл 01234567890",
    invalid_referral_code: "Хүчингүй лавлагаа код",
    accountIdOnlyNumber: "Зөвхөн дугаарыг зөвшөөрөх",
    passwordStrengthError: "Нууц үгээ өөрөө үүсгэ. Нууц үг 8-20 тэмдэгтээс бүрдэх ба тоо үсэгний хослол байх ёстой.",
    tacCodeRequired: "TAC код шаардлагатай",
    invalid_tac: "TAC код буруу",
    tac_is_valid: "TAC кодыг таны холбоо барих дугаар руу илгээсэн.",
    loginFailed: "Нэвтэрч чадаагүй",
    loginSucceed: "Амжилттай нэвтэрч",
    usernameRequired: "Хэрэглэгчийн нэрээ оруулна уу",
    passwordRequired: "Нууц үгээ оруулна уу",
    logoutSucceed: "Амжилттай гарлаа",
    logoutFailed: "Гарч чадахгүй",
    requestSucceed: "Амжилт хүсэх",
    requestFailed: "Хүсэлт амжилтгүй болсон",
    requestProcessing: "Таны хүсэлтийг одоогоор боловсруулж байна",
    requestDelayed: "Хойшлуулах хүсэлт",
    verificationCodeRequired: "Баталгаажуулах TAC код шаардлагатай",
    newPasswordRequired: "Шинэ нууц үг шаардлагатай",
    bankIdRequired: "Банк сонгоно уу",
    bankNameRequired: "Банкны нэр шаардлагатай",
    bankAccHolderRequired: "Банкны данс эзэмшигчийн нэр шаардлагатай",
    bankAccNoRequired: "Банкны дансны дугаар шаардлагатай",
    depositAmountRequired: "Хадгаламжийн дүнг оруулна уу",
    dateRequired: "Огноо сонгоно уу",
    bonusIdRequired: " Бэлгийг сонгоно авна уу",
    session_expired: "Сесс дууссан'",
    account_inactive: "Хэрэглэгчийн нэр/Бүртгэл идэвхгүй байна",
    account_exists: "Хэрэглэгч/Бүртгэлийн ID аль хэдийн байгаа",
    OK: "Tac кодыг амжилттай илгээсэн // tac код",
    ok: "Tac кодыг амжилттай илгээсэн // tac код",
    CLOSE: "UBWIN-ийн Шударга Тоглоомын Нөхцөлийг зөрчсөний улмаас таны бүртгэлийг хориглосон байна.",
    close: "UBWIN-ийн Шударга Тоглоомын Нөхцөлийг зөрчсөний улмаас таны бүртгэлийг хориглосон байна.",
    accountIdRequired: "Хэрэглэгчийн нэрээ оруулна уу'",

    app_id_required: "Хэрэглээний ID шаардлагатай",
    permission_denied: "Зөвшөөрөл татгалцсан",
    account_id_required: "Хэрэглэгчийн нэр/Бүртгэлийн ID шаардлагатай",
    verification_code_required: "Баталгаажуулах код шаардлагатай",
    account_inactive: "Хэрэглэгчийн нэр/Бүртгэл идэвхгүй байна",
    verify_failed: "Баталгаажуулах үйл явц амжилтгүй болсон",
    parent_account_inactive: "Эцэг эхийн бүртгэл идэвхгүй байна",
    transfer_id_required: "Шилжүүлгийн ID шаардлагатай",
    credit_amount_required: "Кретид хэмжээ шаардлагатай",
    duplicate_credit_record: "Давхардсан зээлийн бүртгэл",
    member_wallet_not_exists: "Гишүүн түрийвч байхгүй",
    debit_amount_required: "Дебитийн дүн шаардлагатай",
    duplicate_debit_record: "Давхардсан дебит бүртгэл",
    result_exists: "Үр дүнгийн бүртгэл байгаа",
    debit_record_not_found: "Дебит бүртгэл олдсонгүй",
    bank_id_required: "Банкны ID шаардлагатай",
    bank_acc_no_required: "Банкны дансны дугаар шаардлагатай",
    bank_acc_holder_required: "Банкны данс эзэмшигчийн нэр шаардлагатай",
    bank_already_setup: "Банкны данс тохируулагдсан",
    platform_required: "Платформ шаардлагатай",
    parent_not_exists: "Эцэг эх байхгүй",
    parent_id_required: "Эцэг эхийн үнэмлэх шаардлагатай",
    password_required: "Нууц үг шаардлагатай",
    contact_phone_required: "Холбоо барих утасны дугаар шаардлагатай",
    vip_mode_not_exists: "VIP горим байхгүй",
    session_not_exists: "Таны сессийн хугацаа дууссан тул дахин нэвтэрнэ үү.",
    ticket_id_required: "Тасалбарын ID шаардлагатай",
    ref_id_required: "Лавлах ID шаардлагатай",
    ticket_not_exists: "Тасалбар байхгүй",
    ticket_processed: "Тасалбарыг аль хэдийн боловсруулсан",
    min_deposit_not_met: "Кредит хэмжээ хамгийн багадаа тэнцүү байх ёстой",
    ongoing_promotion: "Танд урамшуулал үргэлжилж байна. Дараа дахин нэхэмжлэнэ үү.",
    invalid_promo_package: "Хүчингүй урамшууллын багц",
    promo_min_deposit_not_met: "Кредит хэмжээ урамшууллын доод хэмжээнд хүрэхгүй байна",
    claim_promo_only_once_a_day: "Урамшуулалыг өдөрт нэг л удаа нэхэмжилж болно",
    first_deposit_unmet: "Өдөр тутмын анхны хадгаламжийн урамшууллыг нэхэмжилж байна.",
    newbie_unmet: "Шинэхэн депосит шагналыг нэхэмжилсэн",
    claim_promo_only_once: "Урамшуулалыг зөвхөн нэг удаа нэхэмжилж болно",
    inner_catch: "Гэнэтийн алдаа",
    systemError: "Системийн алдаа",
    deposit_amount_required: "депосит хэмжээ шаардлагатай",
    target_bank_id_required: "Зорилтот банкны ID шаардлагатай",
    target_bank_acc_no_required: "Зорилтот банкны дансны дугаар шаардлагатай",
    target_bank_acc_holder_required: "Зорилтот банкны данс эзэмшигчийн нэр шаардлагатай",
    deposit_date_required: "Депосит огноо шаардлагатай",
    deposit_method_required: "Депосит арга шаардлагатай",
    min_deposit_not_set: "Депосит доод хэмжээг тогтоогоогүй",
    min_balance_not_set: "Боломжит хамгийн бага үлдэгдэл тогтоогдоогүй",
    bank_account_not_exists: "Банкны данс байхгүй",
    bank_account_inactive: "Банкны данс идэвхгүй",
    withdrawal_amount_required: "Татан авалтын дүн шаардлагатай",
    min_withdrawal_not_set: "Татан авалтын доод хэмжээг тогтоогоогүй",
    bank_member_not_exists: "Зорилтот гишүүн банкны данс байхгүй байна",
    promotion_requirement_not_met: "Танд урамшуулал үргэлжлэж байна",
    invalid_promotion: "Хүчингүй урамшуулал",
    new_password_required: "Шинэ нууц үг шаардлагатай",
    multiplier_not_found: "Систем таны хүсэлтийг одоогоор боловсруулах боломжгүй байна дараа дахин оролдоно уу.",
    contact_phone_exists: "Энэ утас аль хэдийн бүртгэгдсэн",
    BLOCK: "Таны бүртгэл хаагдсан байна",
    tac_expired: "Таны tac кодын хугацаа дууссан. Шинэ tac код асууна уу",
    tac_not_validate: "Так код хараахан батлагдаагүй байна",
    exceed_max_withdrawal: "Татан авалтын дээд хэмжээнээс хэтэрсэн",
    bank_member_inactive: "Хэрэглэгчийн банк идэвхгүй байна",
    bank_member_exists: "Банкны данс аль хэдийн бүртгүүлсэн",
    never_deposited: "Та найз нөхөддөө мөнгө шилжүүлэхийн өмнө дор хаяж нэг мөнгө байршуулах ёстой.",
    transferAmountMustGreaterThanEqual5: "Шилжүүлгийн дүн 5 IDR-ээс их буюу тэнцүү байх ёстой",
    invalid_transfer_amount: "Шилжүүлгийн дүн 5 IDR-ээс их буюу тэнцүү байх ёстой",
    // account_not_exists: "Данс байхгүй байна",
    // ongoing_promotion: "Та үргэлжилсэн сурталчилгаатай хэвээр байна",
    transfer_success: "Амжилттай шилжүүллээ",
    sender_id_required: "Илгээгчийн ID шаардлагатай",
    recipient_id_required: "Хүлээн авагчийн ID шаардлагатай",
    tac_validated: "TAC кодыг баталгаажуулсан. Дахин хүсэлт гаргана уу",
    pending_result_in_game: "Тоглолтын хүлээгдэж буй үр дүн",
    accountIdOnlyNumber: "Зөвхөн хүчинтэй утасны дугаар",
    unfinishgamedetected: "Энэ үйлдлийг үргэлжлүүлэхийн өмнө үнэгүй тоглоомоо дуусгана уу.",
    duplicate_review: "Та өмнө нь шүүмж илгээсэн",
    exceed_withdrawal_frequency: "Та мөнгө авах өдрийн хязгаараас хэтэрсэн байна.(өдөрт 5 удаа)",
    requestTooFrequentAtLeast2Minutes: "Таны хүсэлтийг боловсруулж байна",
    invalidPhoneNumberFormat: "Утасны дугаарын формат буруу",
    fpayUnderMaintenance: "Системийн засвар үйлчилгээ",
    affiliate_not_exists: "Түншлэл байхгүй",
    phoneRequired: "Утасны дугаараа оруулна уу'",
    couponeCodeRequired: "Купон код шаардлагатай",
    coupon_code_required: "Купон код шаардлагатай",
    coupon_not_available: "Купон код боломжгүй",
    contact_email_registered: "Имэйл аль хэдийн байна",
    invalidEmailFormat: "Буруу имэйл формат",
    emailRequired: "Имэйл шаардлагатай",
    paymentMethodRequired: "Төлбөрийн аргыг сонгоно уу",
    depositMethodRequired: "Кредит аргыг сонгоно уу",
    resultIdRequired: "Үр дүнгийн ID шаардлагатай",
    withdrawal_amount_lte_withhold_amount: "Суутгасан дүнгээс бага буюу тэнцүү хэмжээний мөнгө авах.",

    //new
    amount_required: "Хэмжээ шаардлагатай",
    auth_token_required: "Сессын токен шаардлагатай",
    bet_id_required: "Бооцооны дугаар шаардлагатай",
    bonus_unavailable: "Бонус авах боломжгүй",
    client_ip_required: "Үйлчлүүлэгчийн IP шаардлагатай",
    first_deposit_not_met: "Эхний хадгаламж шаардлагатай",
    ftd_required: "Эхний хадгаламж шаардлагатай",
    game_maintenance: "Одоогоор засвар үйлчилгээ хийж байгаа тул дараа дахин оролдоно уу.",
    gateway_acc_required: "Gateway данс шаардлагатай",
    inbox_id_required: "Ирсэн имэйлийн ID шаардлагатай",
    insufficient_rebate: "Хөнгөлөлт хангалтгүй",
    insufficient_ticket: "Тасалбар хангалтгүй",
    is_default_required: "үндсэн сонголт шаардлагатай",
    min_withdrawal_not_met: "Татан авалтын доод хэмжээ хангагдаагүй",
    newbie_not_met: "Шинэхэн танилцаагүй",
    no_changes: "Банкны горим өөрчлөгдөөгүй",
    promotion_not_available: "Урамшуулал байхгүй",
    ref_no_required: "Лавлах дугаар шаардлагатай",
    result_id_required: "Үр дүнгийн ID шаардлагатай",
    search_id_required: "Хайлтын ID шаардлагатай",
    setting_not_set: "Тохиргоог тохируулаагүй",
    tac_required: "Так код шаардлагатай",
    ticket_count_required: "Шаардлагатай тасалбарын хэмжээ",
    vip_not_exists: "VIP гишүүн биш",
    working_date_required: "Ажлын огноо шаардлагатай",
    working_month_required: "Ажлын сар шаардлагатай",
    providerRequired: "Үйлчилгээ үзүүлэгч шаардлагатай",
    invalid_contact_email: "Хүчингүй и-мэйл",
    invalidUsernameFormat: "Хэрэглэгчийн нэр буруу формат",

    secondaryAccountExists: "Хэрэглэгчийн нэр/нууц үг буруу",
    accountInactive: "Бүртгэл идэвхгүй",
    permissionDenied: "Зөвшөөрөлгүй",
    amountRequired: "Шаардлагатай хэмжээ",
    ipAddressRequired: "Шаардлагатай IP хаяг",
    transactionIdRequired: "Гүйлгээний ID шаардлагатай",
    parentIdRequired: "Эцэг эхийн үнэмлэх шаардлагатай",
    auditByRequired: "Шаардлагатай бол аудит хийх",
    systemTypeRequired: "Системийн төрөл шаардлагатай",
    currencyRequired: "Валют шаардлагатай",
    loginIdRequired: "Нэвтрэх ID шаардлагатай",
    referrerIdRequired: "Лавлагчийн ID шаардлагатай",
    agentIdRequired: "Агент ID шаардлагатай",
    profileIdRequired: "Профайлын ID шаардлагатай",
    authTokenRequired: "Хүчингүй сессийн токен",
    promotionIdRequired: "Урамшуулалын ID шаардлагатай",
    promotionNameRequired: "Сурталчилгааны нэр шаардлагатай",
    minDepositRequired: "Хамгийн бага депосит шаардлагатай",
    transferIdRequired: "Шилжүүлгийн ID шаардлагатай",
    betIdRequired: "Бооцооны ID шаардлагатай",
    accountExists: "Хэрэглэгчийн нэр/нууц үг буруу",
    invalidSystemType: "Хүчингүй системийн төрөл",
    accountNotExists: "Бүртгэл байхгүй",
    invalidStatus: "Хүчингүй төлөв",
    samePassword: "Шинэ нууц үг хуучин нууц үгтэй ижил байж болохгүй",
    invalidAmount: "Буруу дүн",
    pendingResultInGame: "Тоглоомын хүлээгдэж буй үр дүн",
    invalidSession: "Хүчингүй сесс",
    promotionExists: "Урамшуулал байгаа",
    promotionNotExists: "Урамшуулал байхгүй",
    currencyNotSupported: "Валютыг дэмждэггүй",
    minimumDepositNotMeet: "депоситын доод хэмжээ хангагдаагүй",
    promotionInactive: "Сурталчилгаа идэвхгүй",
    unableToLaunchSlotGameAtTheMoment: "Одоогоор тоглоомыг эхлүүлэх боломжгүй байна дараа дахин оролдоно уу.",

    //new added: "",
    passwordFormat: "{fname} дор хаяж нэг том нэг жижиг үсэг нэг тоо агуулна.(Жишээ нь: Abcd1234)",
    invalidToken: "Сесс дууссан. Дахин нэвтэрнэ үү",
    favouriteExists: "Дуртай тоглоом бий",
    invalidLogin: "Хэрэглэгчийн нэр/нууц үг буруу",
    invalidAccount: "Хэрэглэгчийн нэр/нууц үг буруу",
    phoneFormat: "Утасны дугаар буруу формат. (Жишээ нь: 976XXXXXXXX эсвэл 976XXXXXXXX)",
}